export default "__VITE_PUBLIC_ASSET__00027617__"